import Konva from "konva";
import { addImageToStage, exportImageBase64, loadImage } from "../util";
import { getCropCoordinates } from "./imageMask";
import { useRawImageUrl } from "@/use/common";
export const getStagePosition = (stage: Konva.Stage, width: number) => {
  const pos = stage.getPointerPosition();
  const stagePos = stage.getPosition();
  const stageScale = stage.getAbsoluteScale();

  const x = (pos!.x - stagePos.x) / stageScale.x;
  const y = (pos!.y - stagePos.y) / stageScale.y;

  setReactPosition(x, y, width / stageScale.x, stage.width(), stage.height());
  return [x, y, stageScale.x];
};

let maxList: number[][] = [],
  maxLeft = -1,
  maxTop = -1,
  maxRight = -1,
  maxBottom = -1;

const initMax = () => {
  maxLeft = -1;
  maxTop = -1;
  maxRight = -1;
  maxBottom = -1;
};

export const getReactPosition = (): number[] => [
  maxLeft,
  maxTop,
  maxRight,
  maxBottom,
];

export const setReactPosition = (
  x: number,
  y: number,
  width: number,
  maxWidth: number,
  maxHeight: number
) => {
  width = width / 2;

  const isVertical = maxWidth < maxHeight;
  const imgWidth = isVertical ? 768 : 1280;
  const imgHeight = isVertical ? 1024 : 720;

  const xScale = maxWidth / imgWidth;
  const yScale = maxHeight / imgHeight;

  if (maxLeft === -1) {
    maxLeft = (x - width) / xScale;
    maxTop = (y - width) / yScale;
    maxRight = (x + width) / xScale;
    maxBottom = (y + width) / yScale;
  } else {
    if (x - width < 0) x = width;
    if (y - width < 0) y = width;
    if (x + width > maxWidth) x = maxWidth - width;
    if (y + width > maxHeight) y = maxHeight - width;

    maxLeft = Math.min(maxLeft, (x - width) / xScale);
    maxTop = Math.min(maxTop, (y - width) / yScale);
    maxRight = Math.max(maxRight, (x + width) / xScale);
    maxBottom = Math.max(maxBottom, (y + width) / yScale);
  }
};

export const setReactPositionToList = () => {
  if (maxList.length) {
    const [l, t, r, b] = maxList[maxList.length - 1];
    if (l === maxLeft && t === maxTop && r === maxRight && b === maxBottom)
      return;
  }
  maxList.push([maxLeft, maxTop, maxRight, maxBottom]);
};

export const undoReactPosition = () => {
  maxList.pop();
  if (maxList.length === 0) return initMax();
  const [l, t, r, b] = maxList[maxList.length - 1];
  maxLeft = l;
  maxTop = t;
  maxRight = r;
  maxBottom = b;
};

export const getLastPosition = () => maxList[maxList.length - 1];

export const resetReactPosition = () => {
  maxList.length = 0;
  initMax();
};

export const mergeImg = async (
  bgMedia: Media,
  replaceMedia: Media,
  masMedia: Media
): Promise<string> => {
  let stage = new Konva.Stage({
    container: "mergeImageDOM",
    width: bgMedia.width,
    height: bgMedia.height,
    draggable: false,
  });

  const bgLayer = new Konva.Layer();
  stage.add(bgLayer);
  const characterLayer = new Konva.Layer();
  stage.add(characterLayer);

  await addImageToStage(stage, bgLayer, bgMedia.url, {
    draggable: false,
    fullScreen: true,
    transform: {
      zIndex: 0,
      position: { x: 0, y: 0 },
      scale: { x: 1, y: 1 },
      offset: { x: 0, y: 0 },
    },
  });
  const [l, t, r, b] = getLastPosition();
  const { x, width, y, height } = await getCropCoordinates(
    await loadImage(useRawImageUrl(masMedia.url))
  );

  await addImageToStage(
    stage,
    characterLayer,
    useRawImageUrl(replaceMedia.url),
    {
      draggable: false,
      fullScreen: false,
      transform: {
        zIndex: 1,
        position: { x, y },
        width: width,
        height: height,
        scale: { x: 1, y: 1 },
        offset: { x: 0, y: 0 },
      },
    }
  );
  return exportImageBase64(stage, bgMedia.width!, bgMedia.height!);
};
